import * as yup from "yup";

const ClientRegistrationSchema = yup.object().shape({
    name: yup
        .string()
        .required('Please Enter Name'),
    address: yup
        .string()
        .required('Please Enter Address'),
    city: yup
        .string()
        .required('Please Enter City'),
    state: yup
        .string()
        .length (2, 'State must be 2 characters')
        .required('Please Enter State'),
    zip: yup
        .string()
        .length (5, 'Zip Code must be 5 digits')
        .matches(/^\d{5}$/, 'Zip must be 5 digits')
        .required('Please Enter Zip Code'),
    phone: yup
        .string()
        .matches(/^[0-9]+$/, "Phone number can only contain digits")
        .transform((value) => value.replace(/[^0-9]/g, ''))
        .length(10, 'Phone must be exactly 10 digits')
        .required('Please Enter Phone Number'),
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    password: yup
        .string()
        .min(8, "Password must be longer than 8 characters")
        .required("Password is required"),
    dob: yup
        .string()
        .trim()
        .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Use MM/DD/YYYY format')
        .required('Please enter birthday MM/DD/YYYY'),
    gender: yup
        .string()
        .required('Please select gender'),    
    termsAndConditions: yup
        .boolean()
        .required('Must agree to Terms And Conditions')
        .oneOf([true], "Must agree to Terms And Conditions"),
    ssn: yup
        .string()
        .required('Social Required to Advance')
});

export default ClientRegistrationSchema;